import { useEffect } from 'react';
import { LandingNavbar } from '@/components/layout/LandingNavbar';
import { Footer } from '@/components/layout/Footer';

import { HeroSection } from '@/components/home/HeroSection';
import { BenefitsSection } from '@/components/home/BenefitsSection';
import { FlowSection } from '@/components/home/FlowSection';
import { SpecializedSectorsSection } from '@/components/home/SpecializedSectorsSection';
import { ValueComparisonSection } from '@/components/home/ValueComparisonSection';
import { ComplianceSection } from '@/components/home/ComplianceSection';
import { AboutSection } from '@/components/home/AboutSection';
import { FAQSection } from '@/components/home/FAQSection';
import { ContactSection } from '@/components/home/ContactSection';
import { ScrollToTop } from '@/components/common/ScrollToTop';

export const HomePage = () => {

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    animatedElements.forEach((el, index) => {
      // Setup initial state for fade-in slide-up
      setTimeout(() => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
        el.style.transition = `opacity 0.6s cubic-bezier(0.16, 1, 0.3, 1), transform 0.6s cubic-bezier(0.16, 1, 0.3, 1)`;
        // Slight stagger for siblings if needed
        const delay = el.style.animationDelay || `${(index % 3) * 0.1}s`;
        el.style.transitionDelay = delay;
        observer.observe(el);
      }, 20);
    });

    return () => {
      animatedElements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  return (
    <div className="home-page" style={{ minHeight: '100dvh', background: '#FFFFFF' }}>
      <LandingNavbar />
      <HeroSection />
      <SpecializedSectorsSection />
      <ValueComparisonSection />
      <BenefitsSection />
      <FlowSection />
      <ComplianceSection />
      {/* <AboutSection /> */}
      <FAQSection />
      <ContactSection />
      <Footer />
      <ScrollToTop />
    </div>
  );
};

